import { createActionConst } from '../../../utils/action.utils';

const TASK_SIMPLE_NAMESPACE = 'TASK_SIMPLE';

export const STORE_TASK_SIMPLE = createActionConst(TASK_SIMPLE_NAMESPACE, 'STORE_TASK_SIMPLE');
export const CLEAR_TASK_SIMPLE = createActionConst(TASK_SIMPLE_NAMESPACE, 'CLEAR_TASK_SIMPLE');
